import FlagIcon from '@/components/Icons/FlagIcon'
import FlagIconFilled from '@/components/Icons/FlagIconFilled'
import InfluencersIcon from '@/components/Icons/InfluencersIcon'
import InfluencersFilledIcon from '@/components/Icons/InfluencersIconFilled'
import LeftDoubleChevronIcon from '@/components/Icons/LeftDoubleChevron'
import LogoutIcon from '@/components/Icons/LogoutIcon'
import ProfileIcon from '@/components/Icons/ProfileIcon'
import ProfileIconFilled from '@/components/Icons/ProfileIconFilled'
import RightDoubleChevronIcon from '@/components/Icons/RightDoubleChevron'
import { useBrandQuery } from '@/services/brands/queries'
import useAccessStore from '@/store/accessStore'
import * as NavigationMenu from '@radix-ui/react-navigation-menu'
import { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import styles from './styles.module.css'

interface MenuItemData {
  to: string
  label: string
  icon: React.ComponentType<{ color: string | undefined }>
  filledIcon?: React.ComponentType<{ color: string | undefined }>
}

const MENU_ITEMS: MenuItemData[] = [
  {
    to: '/campaigns',
    label: 'Campaigns',
    icon: FlagIcon,
    filledIcon: FlagIconFilled,
  },
  {
    to: '/influencers',
    label: 'Influencers',
    icon: InfluencersIcon,
    filledIcon: InfluencersFilledIcon,
  },
]

const PROFILE_ITEMS: MenuItemData[] = [
  {
    to: '/profile',
    label: 'Brand Profile',
    icon: ProfileIcon,
    filledIcon: ProfileIconFilled,
  },
]

interface MenuItemProps {
  item: MenuItemData
  collapsed: boolean
}

function MenuItem({ item, collapsed }: MenuItemProps) {
  const { to, label, icon: Icon, filledIcon: FilledIcon } = item

  return (
    <NavigationMenu.Item>
      <NavLink
        to={to}
        className={({ isActive }) => `${styles.menuItem} ${isActive ? styles.active : ''} ${collapsed ? styles.menuItemCollapsed : ''}`}
      >
        {({ isActive }) => (
          <>
            {isActive && FilledIcon ? <FilledIcon color="#FFF" /> : <Icon color={isActive ? '#FFF' : '#E6A5F3'} />}
            {!collapsed && <span>{label}</span>}
          </>
        )}
      </NavLink>
    </NavigationMenu.Item>
  )
}

export function Sidebar() {
  const [collapsed, setCollapsed] = useState(false)
  const { data: brand } = useBrandQuery()
  const { logout } = useAccessStore()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await logout()
    navigate('/')
  }

  return (
    <div className={`${styles.sidebar} ${collapsed ? styles.collapsed : ''}`}>
      <div className={styles.header}>
        <div className={styles.logoAndText}>
          <div className={styles.logoWrapper}>
            <img src={brand?.brandLogoUrl ?? '/placeholder.jpg'} alt="Logo" />
          </div>
          {!collapsed && (
            <div className={styles.logoTextWrapper}>
              <span>BRAND DASHBOARD</span>
              <span className={styles.logoTextXL}>Boost IT</span>
            </div>
          )}
        </div>

        <button type="button" className={styles.toggleBtn} onClick={() => setCollapsed(!collapsed)}>
          {collapsed ? <RightDoubleChevronIcon /> : <LeftDoubleChevronIcon />}
        </button>
      </div>

      <NavigationMenu.Root orientation="vertical" className={styles.menu}>
        <NavigationMenu.List className={`${styles.menuList} ${collapsed ? styles.menuListCollapsed : ''}`}>
          {!collapsed && (
            <div>
              <p className={styles.menuItemTitle}>MAIN</p>
            </div>
          )}

          {MENU_ITEMS.map((item) => (
            <MenuItem key={item.to} item={item} collapsed={collapsed} />
          ))}

          <div className={styles.listGroup}>
            {collapsed ? <hr className={styles.divider} /> : <p className={styles.menuItemTitle}>PROFILE</p>}
          </div>

          {PROFILE_ITEMS.map((item) => (
            <MenuItem key={item.to} item={item} collapsed={collapsed} />
          ))}
        </NavigationMenu.List>
      </NavigationMenu.Root>

      <button type="button" className={`${styles.footer} ${collapsed ? styles.footerCollapsed : ''}`} onClick={handleLogout}>
        <LogoutIcon />
        {collapsed ? null : <span>Logout</span>}
      </button>
    </div>
  )
}
